import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./Canon/tokens/tokens.css";
import "./heatmap/dashboard.css";
import HeatmapApp from "./heatmap/HeatmapApp.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <HeatmapApp />
  </StrictMode>
);